import { Stack } from 'expo-router';
import React from 'react';

function GetVaroApp() {
  return <Stack screenOptions={{ headerShown: false }} />;
}

export default GetVaroApp;
